import styled from 'styled-components';

import Card from './Card';

const Tooltip = styled(Card)`
  padding: 0.5rem 1rem;
  opacity: 0.85;
`;

Tooltip.Title = styled.h4`
  margin: 0 0 0.5rem 0;
  color: #747474;
  font-weight: 400;
  font-size: 0.9rem;
`;

Tooltip.Value = styled.p`
  font-size: 1.25rem;
  color: #0049ee;
  margin: 0 0 0.5rem 0;
`;

Tooltip.Footer = styled.small``;

export default Tooltip;